export {useFocusable, type FocusableAria, type FocusableOptions} from '../src/interactions/useFocusable';
